import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { useIntl } from "react-intl";
import { Language, RequiredCandidate } from "../../../data/constants";
import { CandidateViewModel } from "../../../model/CandidateViewModel";
import { GetTranslation } from "../../../translations/GetTranslation";
import { AddressFields } from "../../common/AddressFields";
import FormGridCell from "../../common/FormGridCell";
import TranslatedMessage from "../../translations/TranslatedMessage";

type CandidateAddressFieldsProps = {
  candidate: CandidateViewModel;
  isRequired: RequiredCandidate;
  onPropertyValueChanges: (part: Partial<CandidateViewModel>) => void;
};

const CandidateAddressFields: React.FunctionComponent<CandidateAddressFieldsProps> = ({
  candidate,
  isRequired,
  onPropertyValueChanges,
}) => {
  const intl = useIntl();

  const handlePreferredContactChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const contactType = event.target.value;
    if (contactType === "private") {
      onPropertyValueChanges({
        preferredContact: contactType,
        privateIsPreferredContact: true,
        employer: "",
        employerCity: "",
        employerCountry: "",
        employerStreet: "",
        employerStreetNumber: "",
        employerZipCode: "",
      });
    } else {
      onPropertyValueChanges({
        preferredContact: contactType,
        privateIsPreferredContact: false,
      });
    }
  };

  return (
    <>
      <Typography variant="h6">
        <TranslatedMessage id="person.section.address" />
      </Typography>
      <Grid container={true} spacing={4}>
        <AddressFields fieldValues={candidate} fieldsValidation={isRequired} handleChange={onPropertyValueChanges} />
        <FormGridCell size="third">
          <FormControl required error={isRequired.isLanguageEmpty} component="fieldset">
            <FormLabel component="legend">
              <TranslatedMessage id="candidate.field.correspondenceLanguage" />
            </FormLabel>
            <RadioGroup
              aria-label="language"
              name="language"
              value={candidate.correspondenceLanguage}
              onChange={(event) => onPropertyValueChanges({ correspondenceLanguage: event.target.value as Language })}
            >
              <FormControlLabel value="DE" control={<Radio />} label={<TranslatedMessage id="common.language.de" />} />
              <FormControlLabel value="FR" control={<Radio />} label={<TranslatedMessage id="common.language.fr" />} />
              <FormControlLabel value="IT" control={<Radio />} label={<TranslatedMessage id="common.language.it" />} />
            </RadioGroup>
          </FormControl>
        </FormGridCell>
        <FormGridCell size="third">
          <FormControl component="fieldset">
            <FormLabel component="legend">
              <TranslatedMessage id="candidate.field.invoiceRecipient" />
            </FormLabel>
            <RadioGroup
              aria-label="contact1"
              name="contact1"
              value={(candidate.privateIsPreferredContact && "private") || "business"}
              onChange={handlePreferredContactChange}
            >
              <FormControlLabel value="private" control={<Radio />} label={GetTranslation(intl, "common.private")} />
              <FormControlLabel value="business" control={<Radio />} label={GetTranslation(intl, "common.business")} />
            </RadioGroup>
          </FormControl>
        </FormGridCell>
      </Grid>
    </>
  );
};

export default CandidateAddressFields;
